import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface Cart {
  __args: {
    cart_id: string
  }
  [key: string]: any
}

export const cart = {
  __args: {
    cart_id: '%{cartId}'
  }
}

interface CartQueryInput {
  cartId: string
}

export type CartQuery = (input: CartQueryInput) => Promise<ApolloQueryResult<any>>

export const createCartQuery = ({ getQueries }: ServiceDependencies): CartQuery => async ({ cartId }) => {
  const queries = getQueries()
  const query = {
    cart: {
      ...queries.cart,
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  query.cart.__args.cart_id = cartId

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
